"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.breakLines = void 0;
require("core-js/modules/esnext.iterator.constructor.js");
require("core-js/modules/esnext.iterator.map.js");
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const breakLines = exports.breakLines = function breakLines(text) {
  let className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'con-title';
  if (typeof text !== 'string') return null;
  return text.split('\n').map((line, index) => /*#__PURE__*/_react.default.createElement("p", {
    key: index,
    className: className
  }, line));
};